export interface ISqftOption {
    value: number;
    text: string,
    includeInMin: boolean;
    includeInMax: boolean;
};

export const SQFT_OPTIONS: ISqftOption[] = [
    {
        value: 0,
        text: "Any",
        includeInMin: true,
        includeInMax: false,
    },
    {
        value: 500,
        text: "500",
        includeInMin: true,
        includeInMax: true,
    },
    {
        value: 1_000,
        text: "1,000",
        includeInMin: true,
        includeInMax: true,
    },
    {
        value: 2_500,
        text: "2,500",
        includeInMin: true,
        includeInMax: true,
    },
    {
        value: 5_000,
        text: "5,000",
        includeInMin: true,
        includeInMax: true,
    },
    {
        value: 10_000,
        text: "10,000",
        includeInMin: true,
        includeInMax: true,
    },
    {
        value: Number.MAX_SAFE_INTEGER,
        text: "Any",
        includeInMin: false,
        includeInMax: true,
    },
];